import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {
 
    },
    actions: {
 
        fetch(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/la-cote/' + payload.vehicule_id, { params: payload })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
 
        
    },
}
